import Component from "../classes/Component";
import {$dom} from "../helpers/dom";
import {$events} from "../helpers/events";
import variables from "../variables";

const {hasClass, getAll, removeClass, get, addClass} = $dom

const groupSelector = '.js-country-search-group'
const dropdownSelector = '.js-change-country-dropdown'
const inputSelector = '.js-country-search-input'
const iconSelector = '.js-change-country-icon'

export default function () {
    const handleInput = (e) => {
        if (e.target.value.length > 0) {
            addClass(get(dropdownSelector), variables.classNames.visible)
            addClass(get(iconSelector), variables.classNames.visible)
        } else {
            removeClass(get(dropdownSelector), variables.classNames.visible)
            removeClass(get(iconSelector), variables.classNames.visible)
        }
    }

    const handleClick = (e) => {
        if (e.target.closest(groupSelector)) {
            addClass(get(dropdownSelector), variables.classNames.visible)
        } else {
            removeClass(get(dropdownSelector), variables.classNames.visible)
        }
    }

    const handleClickIcon = (e) => {
        console.log('1')
        get(inputSelector).value = ''
        removeClass(get(dropdownSelector), variables.classNames.visible)
        removeClass(get(iconSelector), variables.classNames.visible)
    }

    return new Component({
        name: 'chooseCountry',
        requiredTargets: [groupSelector, dropdownSelector, inputSelector],
        onInit() {
            $events.delegate.on('input', inputSelector, handleInput)
            $events.delegate.on('click', window, handleClick)
            $events.delegate.on('click', iconSelector, handleClickIcon)
        },
        onDestroy() {
            $events.delegate.off('input', inputSelector, handleInput)
            $events.delegate.off('click', window, handleClick)
            $events.delegate.off('click', iconSelector, handleClickIcon)
        },
    })

}